import React from 'react';
import Card from '../ui/Card';
import Text from '../ui/Text';

function SummaryStatCard({ item }) {
  return (
    <Card
      as="div"
      variant="compact"
      padding="md"
      className={`summary-strip-card ${item.tone || 'neutral'}`}
    >
      <div className="summary-strip-card-topline">
        <span className="summary-strip-card-label">{item.label}</span>
        {item.icon && <i className={`fas ${item.icon}`}></i>}
      </div>
      <strong className="summary-strip-card-value">{item.value}</strong>
      {item.subtitle ? (
        <Text as="p" variant="caption" className="summary-strip-card-subtitle">
          {item.subtitle}
        </Text>
      ) : null}
    </Card>
  );
}

export default SummaryStatCard;
